module.exports = "https://cdn.realtymogul.com/static/media/slide_diversify_efficient_frontier.c1f94f2e.png";